import { render, staticRenderFns } from "./MoveBillStockModal.vue?vue&type=template&id=5825e9f4&scoped=true&"
import script from "./MoveBillStockModal.vue?vue&type=script&lang=js&"
export * from "./MoveBillStockModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveBillStockModal.vue?vue&type=style&index=0&id=5825e9f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5825e9f4",
  null
  
)

export default component.exports